import React, { useState } from "react";
import "./Career.css";

function Career() {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const jobList = [
    {
      title: "Admin Produksi",
      location: "Gunung Putri, Bogor",
      allowance: "BPJS Ketenagakerjaan",
      subject: "Admin Produksi 2025",
      jobDescription: [
        "Mencatat, menginput, dan mengelola data hasil produksi harian ke sistem.",
        "Memastikan akurasi dan ketepatan data.",
        "Membuat laporan produksi dan memastikan kelengkapan dokumen.",
        "Memastikan jadwal produksi disesuaikan dengan kebutuhan pelanggan dan kapasitas produksi.",
        "Mendukung proses penjadwalan produksi dan distribusi material.",
        "Berkoordinasi dengan bagian produksi, gudang, dan QC.",
        "Menjaga kerapihan arsip dan data administrasi produksi.",
        "Memastikan semua data dicatat dengan akurat dan tepat waktu.", 
      ],
      qualifications: [
        "Perempuan ",
        "Usia maks. 35 tahun",
        "Diutamakan memiliki pengalaman min. 1  tahun sebagai admin produksi",
        "Pemahaman tentang alur proses administrasi & mahir dalam microsoft office"
      ],
      skills: [
        "Detail oriented",
        "Teamwork",
        "Komunikasi efektif",
        "Manajemen waktu",
        "Problem solving",
        "Organizational"
      ],
    },
    {
      title: "Kepala Gudang",
      location: "Gunung Putri, Bogor",
      allowance: "BPJS Ketenagakerjaan",
      subject: "Kepala Gudang 2025",
      jobDescription: [
        "Mengawasi dan mengoordinasikan seluruh aktivitas gudang, termasuk penerimaan, penyimpanan, pengiriman, dan pengelolaan inventaris",
        "Mengatur tata letak dan pemanfaatan ruang gudang secara efisien sesuai prosedur keamanan dan penanganan barang.",
        "Menyusun kebijakan operasional untuk meningkatkan efisiensi kerja.",
        "Mengelola stok dan melakukan rekonsiliasi data secara manual dan komputerisasi.",
        "Mengawasi pelabelan, pemrosesan, dan pengemasan barang masuk dan keluar.",
        "Mengembangkan tim gudang melalui penetapan target, bimbingan, dan evaluasi berkala.",
        "Menganalisis data dan membuat laporan stock opname bulanan untuk manajemen.",
        "Berkoordinasi dengan tim terkait seperti sales dan keuangan untuk kelancaran pasokan.",
        "Memantau anggaran operasional dan belanja gudang.",
        "Menjaga dokumentasi dan pencatatan kegiatan gudang yang akurat.",
        "Menyusun laporan dan statistik secara rutin.",
      ],
      qualifications: [
        "Laki-laki",
        "Usia maks. 35 tahun",
        "Diutamakan memiliki pengalaman di bidang gudang,  min. 1 tahun di posisi manajerial",
        "Pemahaman tentang teknologi dan otomasi gudang yang relevan",
      ],
      skills: [
        "Teamwork",
        "Leadership",
        "Multitasking",
        "Skill interpersonal yang baik",
        "Kemampuan komunikasi lisan & tulisan yang baik",
        "Manajemen proyek",
        "Detail oriented",
        "Problem solving",
      ],
    },
    {
      title: "Admin Hutang Dagang",
      location: "Gunung Putri, Bogor",
      allowance: "BPJS Ketenagakerjaan",
      subject: "AP Admin 2025",
      jobDescription: [
        "Menerima, memeriksa, dan mencocokkan dokumen pembelian (PO, faktur, bukti penerimaan barang).",
        "Menginput data tagihan supplier ke sistem keuangan atau akuntansi.",
        "Menyiapkan jadwal dan dokumen pembayaran agar tepat waktu sesuai jatuh tempo.",
        "Memastikan keakuratan nominal, pajak, dan potongan dalam setiap transaksi.",
        "Mengumpulkan dan memverifikasi faktur pajak pembelian dari supplier.",
        "Melakukan rekonsiliasi hutang dengan laporan keuangan dan buku besar.",
        "Menyusun laporan hutang dagang secara berkala untuk tim keuangan atau manajemen.",
        "Berkoordinasi dengan bagian pembelian dan supplier terkait status pembayaran",
      ],
      qualifications: [
        "Wanita, usia maks.30 tahun",
        "Pendidikan min. SMA/SMK",
        "Berpengalaman min. 1 tahun di bidang yang sama",
        "Teliti, disiplin, dan komunikatif",
        "Mampu berkerja dengan target",
      ],
      skills: [
        "Detail-Oriented & Accurate",
        "Payment Tracking  & Scheduling",
        "Reconciliation",
        "Aging Report Analysis",
        "Proficiency in Excel & Accounting Software",
        "Communication & Coordination",
        "Confidentiality & Integrity ",
        "Time Management",
      ],
    },
  ];

  const handleOpenModal = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedJob(null);
    setShowModal(false);
  };

  return (
    <div className="career-page">
      {/* Hero Section */}
      <section className="contact-hero text-center text-white">
        <h1 className="contact-title">Karir</h1>
        <p className="contact-subtitle">Jadilah Bagian dari Formebel Indonesia</p>
      </section>

      {/* Job List */}
      <section className="contact-info container py-5">
        <div className="text-center mb-4">
          <h1>Kami Sedang Mencari</h1>
        </div>

        <div className="row g-4 justify-content-center">
          {jobList.map((job, index) => (
            <div key={index} className="col-md-4">
              <div className="contact-card text-center">
                <h5 className="contact-label">{job.title}</h5>
                <hr />
                <button
                  className="btn btn-brown"
                  onClick={() => handleOpenModal(job)}
                >
                  Detail Lebih Lanjut
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Modal */}
      {showModal && selectedJob && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <h3>{selectedJob.title}</h3>
            <p><strong>Lokasi:</strong> {selectedJob.location}</p>
            <p><strong>Tunjangan:</strong> {selectedJob.allowance}</p>

            <div className="modal-section">
              <h5>Deskripsi</h5>
              <ul>
                {selectedJob.jobDescription.map((desc, i) => (
                  <li key={i}>{desc}</li>
                ))}
              </ul>
            </div>

            <div className="modal-section">
              <h5>Kualifikasi</h5>
              <ul>
                {selectedJob.qualifications.map((q, i) => (
                  <li key={i}>{q}</li>
                ))}
              </ul>
            </div>

            <div className="modal-section">
              <h5>Skill</h5>
              <ul>
                {selectedJob.skills.map((s, i) => (
                  <li key={i}>{s}</li>
                ))}
              </ul>
            </div>

            <p><strong>CV & Surat Lamaran kirim ke:</strong></p>
            <p><strong>Email:</strong> Formeb.Hrd@gmail.com</p>
            <p><strong>Subject:</strong> {selectedJob.subject}</p>

            <button className="btn btn-secondary mt-3" onClick={handleCloseModal}>
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Career;
